import { IApplicationState } from '../../types/redux';
import { selectComparePageType } from './selectComparePageType';
import { selectIds } from '../ids';
import { selectNewbuildingsCount } from '../newbuildingsCompare';

export function selectIsCompareEmpty(state: IApplicationState): boolean {
  if (selectComparePageType(state) === 'newbuildings') {
    return selectNewbuildingsCount(state) === 0;
  }

  return selectIds(state).length === 0;
}
